import * as yup from "yup";

export const schema = [
  yup.object({
    name: yup
      .string()
      .required("Please provide the Role Name")
      .max(50, "Name cannot exceed 50 characters")
      .matches(
        /^[A-Za-z0-9 ]+$/,
        "Role Name can only contain letters, numbers, and spaces"
      ),

    description: yup
      .string()
      .optional()
      .max(250, "Role Description cannot exceed 250 characters"),

    Admin_Access: yup
      .string()
      .required("Please select Role Category(Admin or User)")
      .oneOf(["true", "false"], "Please select a valid role category"),

    web_permission: yup
      .string()
      .required("Please select at least one Permission")
      .nullable()
      .notOneOf([null, ""], "Permission is required"),

    permission: yup
      .string()
      .required("Please select at least one Permission")
      .nullable()
      .notOneOf([null, ""], "Permission is required"),

    // Simple object validation
    modulePermissions: yup.object().optional().nullable(),
  }),
];

export const CreateRoleConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "name",
        label: "roleformlabels.name",
        type: "input",
        mandatory: "true",
      },
      {
        name: "Admin_Access",
        label: "Role Category",
        type: "radio",
        mandatory: "true",
        options: [
          { label: "Admin", value: "true" },
          { label: "User", value: "false" },
        ],
      },
      {
        name: "web_permission",
        containerId: "container_web_permission",
        label: "Web Permission (Select Modules)",
        type: "hier_select",
        mandatory: "true",
      },
      {
        name: "module_permissions_section",
        type: "module_permissions_grid",
        label: "Module Access Permissions",
        containerId: "container_module_permissions",
        helpText:
          "Configure view, edit, and delete permissions for each selected module",
        fullWidth: true,
      },
      {
        name: "description",
        label: "roleformlabels.description",
        type: "text_area",
        maxLength: 250,
        fullWidth: true,
      },
    ],
  },
];
